import React from 'react'

const BetterSkeleton = ({
    pathList,
    handleMouseOver,
    handleMouseLeave,
    infoValues
}: {
    pathList: string[]
    handleMouseOver: ({ title, value }: { title: string; value: string }) => void
    handleMouseLeave: () => void
    infoValues: { title: string; value: string }[]
}) => {
    const Pin = ({ path, data }: { path: string; data: { title: string; value: string } }) => {
        return (
            <path
                className="info-path"
                onMouseOver={() => {
                    data ? handleMouseOver(data) : null
                }}
                onMouseLeave={() => {
                    handleMouseLeave()
                }}
                d={data ? path : ''}
                fill={data ? '#01F5D4' : '#171717'}
            />
        )
    }

    return (
        <div className="position-absolute h-100">
            <svg
                className="skeleton-vector"
                viewBox="0 0 242 497"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ touchAction: 'auto', msTouchAction: 'auto' }}
            >
                <defs>
                    <g id="pin">
                        <circle cx="0" cy="0" r="7" fill="white" stroke="green" strokeWidth="2" />
                    </g>
                </defs>
                <g clipPath="url(#clip0_1_655)" id="skeleston">
                    {!!infoValues &&
                        !!pathList &&
                        pathList.map((path, i) => {
                            return <Pin path={path} data={infoValues[i] ? infoValues[i] : null} key={i} />
                        })}
                </g>
                <defs>
                    <clipPath id="clip0_1_655">
                        <rect width="241.086" height="496.299" fill="white" transform="translate(0.789062 0.519409)" />
                    </clipPath>
                </defs>
            </svg>
        </div>
    )
}

export default BetterSkeleton
